module.exports = __webpack_public_path__ + "static/media/view3.2fa68e39.jpg";